'use client';
import { AnimatePresence, motion } from 'framer-motion';
import { useDisclosure } from '@bitmap/utils/hooks/use-disclosure';
import { BLOCKS } from '@contentful/rich-text-types';
import { IFaq } from '@/src/interfaces/generated/contentful';
import { Box } from '@/src/packages/components/ui/Box';
import { Heading } from '@/src/packages/components/ui/Heading';
import { Plus } from '@/src/packages/components/ui/Plus';
import { RichText } from '@/src/packages/components/ui/RichText';
import { Paragraph } from '@/src/packages/components/ui/Paragraph';

export const AccordionItem = ({ faq }: { faq: IFaq }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box className="flex-1">
      <Box
        className="flex cursor-pointer items-center"
        onClick={onToggle}
        paddingY={4}
      >
        <Heading as="h3" size="h2" className="flex-1">
          {faq.fields.question}
        </Heading>

        <Box className="ml-auto h-5 w-5">
          <Plus isOpen={isOpen} />
        </Box>
      </Box>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            initial="collapsed"
            animate="open"
            exit="collapsed"
            className="overflow-hidden"
            variants={{
              open: { height: 'auto' },
              collapsed: { height: 0 },
            }}
          >
            <Box paddingBottom="gutter" className="max-w-3xl">
              <RichText
                data={faq.fields.answer}
                options={{
                  renderNode: {
                    [BLOCKS.PARAGRAPH]: (node, children) => (
                      <Paragraph>{children}</Paragraph>
                    ),
                  },
                }}
              />
            </Box>
          </motion.section>
        )}
      </AnimatePresence>
    </Box>
  );
};
